import React, { useEffect, useReducer } from "react";
import { Box, Grid, CircularProgress } from "@mui/material";
import './styles/loader.css';
import lockedReducer from "./reducer";

export const loader = {
    on: () => { },
    off: () => { }
}

let interval = 0

    const moveDot = (setState) => {
        setState((prev) => ({ ...prev, dots: (prev.dots + 1) % 4 }))
    }

const Loading = ({ nofixed }) => {

    const [state, setState] = useReducer(lockedReducer, {
        loading: false,
        message: '',
        dots: 0,
    })

    useEffect(() => {
        loader.on = () => setState({ loading: true })
        loader.off = () => setState({ loading: false })
    }, []) 

    useEffect(() => {

        clearInterval(interval)
        if (state.loading)
            interval = setInterval(()=>moveDot(setState), 1000)
        return () => {
            clearInterval(interval)
        }
    }, [state.loading])

    return (
        <>
            {
                (state.loading) &&
                <div className={`loading-container ${nofixed ? 'nofixed' : ''}`}>
                    <Box className="loading">
                        <Grid container spacing={2}>
                            <Grid item lg={12} md={12} sm={12} xs={12} id="loading-grid">
                                <CircularProgress id="refresh-icon" />
                            </Grid>
                            <Box display='flex' alignItems='center' width='7rem'>
                                {state.message ? state.message : 'Carregando'}{Array(state.dots).fill('.').join('')}
                            </Box>
                        </Grid>
                    </Box>
                </div>
            }
        </>
    )
}

export default Loading
